import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete'; // Ícone de exclusão

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: 8,
    padding: '8px 16px',
    backgroundColor: '#f8d7da', // Cor de fundo vermelha clara (indicando erro/exclusão)
    transition: 'transform 0.1s, box-shadow 0.1s',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width: '200px',
    display: 'flex',
    alignItems: 'center', // Alinha ícone e texto
    justifyContent: 'center',
    gap: '8px', // Espaço entre o ícone e o texto
  },
  typography: {
    color: theme.palette.error.main, // Cor para destacar como erro/exclusão
  },
  dialog: {
    minWidth: '300px',
  },
}));

function DeleteButtonWithModal({ onDelete }) {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);

  const handleClickDelete = () => {
    setOpenDialog(true); // Abre o modal de confirmação ao clicar no botão de exclusão
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Fecha o modal sem excluir
  };

  const handleConfirmDelete = () => {
    onDelete(); // Chama a função de exclusão fornecida pelo componente pai
    setOpenDialog(false); // Fecha o modal após a exclusão
  };

  return (
    <div>
      {/* Botão de Exclusão */}
      <ButtonBase
        onClick={handleClickDelete}
        className={classes.button}
        onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
        onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        aria-label="Excluir"
      >
        <DeleteIcon style={{ color: '#d32f2f' }} />
        {/* <DeleteIcon color="inherit" /> */}
        <Typography variant="body2" className={classes.typography}>
          Excluir
        </Typography>
      </ButtonBase>

      {/* Modal de Confirmação */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        className={classes.dialog}
      >
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Tem certeza de que deseja excluir este item? Esta ação não pode ser
            desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DeleteButtonWithModal;
